// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"09f9aeb3","239":"7205f491","455":"a9656b16","488":"6feaf2b1","977":"5a83bdb0"}[chunkId] + ".chunk.js";
};